<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Klienci</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Klienci:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Aktywni i zablokowani</option>
          <option value="only">Tylko zablokowani</option>
        </select>

        <div v-if="$page.props.can['manage all clients']">
          <label class="pt-4 block text-gray-700">Opiekun:</label>
          <multiselect-input v-model="form.user" class="mt-1 w-full" :options="users_opt" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
        </div>

        <shtax-checkbox class="pt-6 w-full" v-model:checked.sync="form.has_not_user" :checked="form.has_not_user" label="Bez opiekuna" />
      </search-filter>
      <inertia-link class="btn-shtax" :href="route('clients.create')"  v-if="$page.props.can['add clients']">
        <span>Nowy</span>
        <span class="hidden md:inline">Klient</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-4">Nazwa</th>
          <th class="px-3 pt-6 pb-4">Adres</th>
          <th class="px-3 pt-6 pb-4">NIP</th>
          <th class="px-3 pt-6 pb-4">REGON</th>
          <th class="px-3 pt-6 pb-4">JDG</th>
          <th class="px-3 pt-3 pb-2">Forma<br>opodatkowania</th>
          <th class="px-3 pt-3 pb-2" colspan="2">Data<br>rozpoczęcia</th>
        </tr>
        <tr v-for="client in clients.data" :key="client.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-orange-50': (client.has_wapro_kontrahent && !client.has_wapro_firma) || (!client.has_wapro_kontrahent && client.has_wapro_firma), 'bg-red-50': !client.has_wapro_kontrahent && !client.has_wapro_firma}">
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.show', client.id)">
                <span>
                  {{ client.name }}
                  <icon v-if="client.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
                </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.show', client.id)">
              <span>
                {{ client.address }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.show', client.id)">
              <span>
                {{ client.nip }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.show', client.id)">
              <span>
                {{ client.regon }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.show', client.id)">
              <span>
                {{ client.jdg }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.show', client.id)">
              <span>
                {{ client.forma_opodatkowania }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('clients.show', client.id)">
              <span>
                {{ client.created_at }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-3 flex items-center" :href="route('clients.show', client.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="clients.data.length === 0">
          <td class="border-t px-3 py-2" colspan="8">Nie znaleziono kontrahentów.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-3" :links="clients.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Kontrahenci' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    ShtaxCheckbox,
    MultiselectInput
  },
  layout: Layout,
  props: {
    filters: Object,
    clients: Object,
    users: Array
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        has_not_user: this.filters.has_not_user == 'true',
        user: this.filters.user
      },
      users_opt: this.users.map(user => {return {'id': user.id, 'name': user.first_name +' '+ user.last_name}}),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('clients'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  }
}
</script>
